module.exports = __webpack_public_path__ + "img/logo_small.467d8b44.svg";